import { render, staticRenderFns } from "./tab8-bei.vue?vue&type=template&id=ad2210ec&scoped=true&"
import script from "./tab8-bei.vue?vue&type=script&lang=js&"
export * from "./tab8-bei.vue?vue&type=script&lang=js&"
import style0 from "./tab8-bei.vue?vue&type=style&index=0&id=ad2210ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2210ec",
  null
  
)

export default component.exports